import { Link } from "react-router-dom";
import { testimonials } from "../../../mocks/testimonials";

export default function TestimonialsSnippet() {
  const shown = testimonials.slice(0, 3);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span
              className="text-amber-600 text-xs font-bold tracking-widest uppercase"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Customer Reviews
            </span>
            <h2
              className="text-4xl lg:text-5xl font-bold text-zinc-900 mt-3"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              What Our Customers Say
            </h2>
          </div>
          <Link
            to="/testimonials"
            className="flex items-center gap-2 text-amber-600 font-semibold text-sm hover:gap-3 transition-all whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            View All Reviews
            <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></div>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {shown.map((t) => (
            <div key={t.id} className="bg-stone-50 rounded-lg p-7 border border-stone-100">
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-500 text-sm"></i>
                  </div>
                ))}
              </div>
              <p
                className="text-zinc-600 text-sm leading-relaxed mb-6 italic"
                style={{ fontFamily: "'Raleway', sans-serif" }}
              >
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-600 rounded-full text-white text-xs font-bold">
                  {t.avatar}
                </div>
                <div>
                  <p className="text-zinc-800 text-sm font-semibold" style={{ fontFamily: "'Raleway', sans-serif" }}>{t.name}</p>
                  <p className="text-zinc-400 text-xs" style={{ fontFamily: "'Raleway', sans-serif" }}>{t.location} · {t.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
